export default __webpack_public_path__ + "static/media/lockaccounticon.4d1ce0c0.svg";